import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CoreSeoPages } from '@app/store/enums/core-seo-pages';
import { CoreService } from '../../services/core.service';
import { FAQCategories } from '../../services/faqs.service';
import { SeoService } from '../../services/seo.service';
import { SystemUserTypes } from 'shared-library';
import { Subscription } from 'rxjs';
import { SessionInfo } from '@app/store/models/session-info.interface';

@Component({
  selector: 'app-core-referral-landing-page',
  templateUrl: './core-referral-landing-page.component.html',
  styleUrls: ['./core-referral-landing-page.component.scss']
})
export class CoreReferralLandingPageComponent implements OnInit, OnDestroy {

  session_info: SessionInfo
  subscriptions: Subscription[] = []
  faq_category = FAQCategories.REFERRAL

  constructor(
    private router: Router,
    private seo: SeoService,
    public coreService: CoreService
  ) {
    this.subscriptions.push(this.coreService.session_dataObservable.subscribe(si => this.session_info = si))
    this.seo.generateMetaTags(CoreSeoPages.REFERRAL)
  }

  ngOnInit(): void {
    if (this.coreService.isLoggedIn()) {
      if (this.coreService.getSessionInfo().user_details.user_category !== SystemUserTypes.USER) {
        this.router.navigateByUrl("/404")
      }
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.map(subscription => subscription.unsubscribe())
  }

  getStarted() {
    const session_info = this.coreService.getSessionInfo()
    if (session_info) {
      session_info.last_routes.lastvisited = `${SystemUserTypes.USER}/referral`
      this.coreService.setSessionData(session_info)
    }
    this.router.navigateByUrl(this.coreService.isLoggedIn() ? "user/referrals" : "/auth/signin")
  }

}
